import { render, staticRenderFns } from "./addScore.vue?vue&type=template&id=360fc65a&scoped=true&"
import script from "./addScore.vue?vue&type=script&lang=js&"
export * from "./addScore.vue?vue&type=script&lang=js&"
import style0 from "./addScore.vue?vue&type=style&index=0&id=360fc65a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360fc65a",
  null
  
)

export default component.exports